import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as FullStory from '@fullstory/browser';

export function useFullStoryRouteGuard() {
  const location = useLocation();
  const wasAdmin = useRef<boolean | null>(null);

  useEffect(() => {
    const isAdminPanel = location.pathname.startsWith('/admin-panel');

    if (isAdminPanel && wasAdmin.current !== true) {
      // Transitioning onto an admin page — start (or resume) capture.
      if (FullStory.isInitialized()) FullStory.FullStory('restart');
    } else if (!isAdminPanel && wasAdmin.current !== false) {
      // Transitioning off an admin page (or initial non-admin load) — stop capture.
      if (FullStory.isInitialized()) FullStory.FullStory('shutdown');
    }

    wasAdmin.current = isAdminPanel;
  }, [location.pathname]);
}
